export default __webpack_public_path__ + "static/media/compare__item-icon-2.a64c5e02.svg";